import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const fetchDoctors = async (
  getDoctors,
  data,
  setNearestTurn
) => {
  if (!data?.idDarmangah) {
    return;
  }

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_RETURN_APPOINTMENT}`,
    false,
    {
      ...data,
    }
  ).then((response) => { 
    if (response.data.resCode === 1) {
      
      getDoctors(response.data.Data.listItem);
      setNearestTurn(response.data.Data.NazdickTarinNobat);
    } else {
      // SwalAlert('error', response.data.resMessage, false);
    }
  });
};

// idService: data?.pageConfig === 1 ? data.selectedService.id : 0,
// idSpeciality: data?.pageConfig === 1 ? 0 : data.selectedService.id,
// startDate:
//   data.dateRange?.length > 0
//     ? moment(data.dateRange.FromDate, "jYYYY/jM/jD").format("YYYY/MM/DD")
//     : moment().format("YYYY/MM/DD"),
// endDate:
//   data.dateRange?.length > 0
//     ? moment(data.dateRange.ToDate, "jYYYY/jM/jD").format("YYYY/MM/DD")
//     : moment().add(4, "months").format("YYYY/MM/DD"),
// topRecord: 30,
